<template>
  <v-container>
    <!-- MESSAGE NORMAL MONTH -->
    <check-normal-month
      v-if="showCheckNormalMonth"
      @cancel="showCheckNormalMonth = false"
      @accept="monthWithoutEvents"
    />
    <!-- MENU -->
    <v-menu
      v-model="showMenu"
      absolute
      :position-x="x"
      :position-y="y"
      offset-y
      :close-on-click="false"
      :close-on-content-click="false"
      :disabled="readOnlyCalendar && (approved === 0 || approved === 1)"
    >
      <!-- FULL MENU -->
      <v-card v-if="allowedDay" width="470">
        <v-btn
          class="close-btn-style"
          color="white orange--text"
          small
          absolute
          depressed
          top
          right
          fab
          @click="closeMenu"
        >
          <v-icon size="24">close</v-icon>
        </v-btn>
        <v-card-title class="headline orange-mp lighten-2 px-4" primary-title>
          <v-layout align-center>
            <v-flex d-inline-flex align-baseline>
              <v-flex class="day-text-style">
                {{ daySelected }}
              </v-flex>
              <v-flex class="month-text-style">
                de {{ monthSelected | monthName }}
              </v-flex>
            </v-flex>
            <v-flex v-if="notEvent" class="line-1" px-2>
              <v-btn
                class="text-capitalize"
                depressed
                block
                color="white orange--text"
                @click="newEvent"
              >
                <font-awesome-icon
                  class="mr-2"
                  :style="{ color: '#FF9800' }"
                  size="lg"
                  :icon="['fal', 'plus']"
                />
                Agregar
              </v-btn>
            </v-flex>
            <v-flex v-else class="line-1" px-2>
              <v-btn
                class="text-capitalize"
                depressed
                block
                color="white orange--text"
                @click="deleteEvent"
              >
                <font-awesome-icon
                  class="mr-2"
                  :style="{ color: '#FF9800' }"
                  size="lg"
                  :icon="['fal', 'times-circle']"
                />
                Eliminar
              </v-btn>
            </v-flex>
            <v-flex></v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text class="px-4">
          <v-flex v-if="notEvent">
            <p class="caption">
              Seleccione la cantidad de días para la novedad:
            </p>
            <v-flex d-flex align-center>
              <v-flex class="title label-width">Días</v-flex>
              <v-slider
                v-model="amountOfDays"
                :thumb-size="21"
                min="1"
                :max="maxDays"
                thumb-label="always"
                always-dirty
                color="#466EA5"
              ></v-slider>
              <v-flex class="caption text-xs-center max-days-style" pl-1>
                <v-flex>
                  <b>{{ maxDays }}</b>
                </v-flex>
                <v-flex class="text-9">máximo</v-flex>
              </v-flex>
            </v-flex>
            <v-divider></v-divider>
          </v-flex>
          <!-- <v-text-field
            type="number"
            min="1"
            :max="maxDays"
            v-model="amountOfDays"
            label="Dias"
            box
          /> -->
          <p class="mt-3">
            Por favor seleccione el tipo de novedad para éste día:
          </p>
          <v-radio-group v-model="odsAlt">
            <v-radio
              color="#C46D24"
              v-for="(ods, index) in optionsODS"
              :key="index"
              :label="ods"
              :value="index"
            ></v-radio>
          </v-radio-group>
          <v-flex v-if="showUpdateBtn" class="line-1" px-2>
            <v-btn
              class="text-capitalize"
              depressed
              block
              dark
              color="#C46D24"
              @click="updateEvent"
            >
              <font-awesome-icon
                class="mr-2"
                :style="{ color: '#FFFFFF' }"
                size="lg"
                :icon="['fal', 'sync']"
              />
              Actualizar
            </v-btn>
          </v-flex>
        </v-card-text>
      </v-card>
      <!-- RESTRICTED MENU -->
      <v-card v-else width="470">
        <v-btn
          class="close-btn-style"
          color="white orange--text"
          small
          absolute
          depressed
          top
          right
          fab
          @click="closeMenu"
        >
          <v-icon size="24">close</v-icon>
        </v-btn>
        <v-card-title class="headline orange-mp lighten-2 px-4" primary-title>
          <v-layout align-center>
            <v-flex d-inline-flex align-baseline>
              <v-flex class="day-text-style">
                {{ daySelected }}
              </v-flex>
              <v-flex class="month-text-style">
                de {{ monthSelected | monthName }}
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text class="px-4">
          <font-awesome-icon
            :style="{ color: '#E53935', fontSize: 36 + 'px' }"
            :icon="['fas', 'info-circle']"
          />
          <v-flex class="title mt-3">
            Día con restricción
          </v-flex>
          <p class="my-2">
            El día seleccionado se encuentra fuera del rango de su contrato.
          </p>
        </v-card-text>
      </v-card>
    </v-menu>
    <!-- ALERT -->
    <!-- <v-alert
      class="max-min-width"
      outline
      v-model="readOnlyCalendar"
      dismissible
      color="#6E8F82"
      type="success"
    >
      {{ message }}
    </v-alert> -->
    <!-- ALT CONTENT -->
    <v-layout v-if="loading">
      <font-awesome-icon
        :style="{ color: '#E0E0E0', fontSize: 200 + 'px' }"
        :icon="['fas', 'cloud-download-alt']"
      />
    </v-layout>
    <!-- CONTENT -->
    <v-layout v-else column>
      <!-- TITLE -->
      <v-layout>
        <v-flex d-inline-flex align-baseline>
          <v-flex class="title-section">Eventos</v-flex>
        </v-flex>
      </v-layout>
      <!-- INFO HEADER -->
      <v-layout class="max-min-width">
        <v-flex>
          <v-flex d-inline-flex align-baseline>
            <v-flex>
              <h2>
                {{ currentMonth }}
              </h2>
            </v-flex>
            <v-flex pl-2>
              <h3>
                <b>{{ currentYear }}</b>
              </h3>
            </v-flex>
            <!-- NEXT MONTH -->
            <v-flex v-if="checkEndDate" pl-3>
              <v-btn
                class="text-capitalize"
                color="#466EA5"
                block
                :dark="true"
                @click="checkNextMonth"
              >
                <font-awesome-icon
                  class="mr-2"
                  :style="{ color: '#FFFFFF' }"
                  size="lg"
                  :icon="['fal', 'calendar-exclamation']"
                />
                Habilitado {{ currentRealMonth }}
              </v-btn>
            </v-flex>
            <!-- BACK TO ST MONTH -->
            <v-flex v-if="currentMonthNumber === currentRealMonthNumber" pl-3>
              <v-btn
                class="text-capitalize"
                color="#466EA5"
                block
                :dark="true"
                @click="backSTMonth"
              >
                <font-awesome-icon
                  class="mr-2"
                  :style="{ color: '#FFFFFF' }"
                  size="lg"
                  :icon="['fal', 'calendar-exclamation']"
                />
                Cargar {{ currentSTMonth }}
              </v-btn>
            </v-flex>
          </v-flex>
          <v-flex>
            Seleccione el día, o días, uno a la vez, que va a reportar.
          </v-flex>
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <!-- BUTTONS UP -->
        <v-flex
          v-if="(readOnlyCalendar && approved === 2) || approved === null"
          d-flex
          class="buttons-up-container"
          px-1
        >
          <!-- MONTH WITHOUT EVENTS -->
          <v-flex pt-2 px-2>
            <v-btn
              class="text-capitalize"
              color="#6E8F82"
              block
              :dark="sendButton"
              :disabled="!sendButton"
              @click="showCheckNormalMonth = true"
            >
              <font-awesome-icon
                class="mr-2"
                :style="{ color: '#FFFFFF' }"
                size="lg"
                :icon="['fal', 'clipboard-list-check']"
              />
              Mes sin novedad
            </v-btn>
          </v-flex>
          <v-flex pt-2 px-2>
            <v-btn
              v-if="approved !== 2"
              class="text-capitalize"
              color="#466EA5"
              block
              :dark="!sendButton"
              :disabled="sendButton"
              @click="sendODSConfirm"
            >
              <font-awesome-icon
                class="mr-2"
                :style="{ color: '#FFFFFF' }"
                size="lg"
                :icon="['fal', 'paper-plane']"
              />
              Enviar para aprobación
            </v-btn>
            <v-btn
              v-else
              class="text-capitalize"
              color="#466EA5"
              block
              :dark="!sendButton"
              :disabled="sendButton"
              @click="sendODSConfirmRev"
            >
              <font-awesome-icon
                class="mr-2"
                :style="{ color: '#FFFFFF' }"
                size="lg"
                :icon="['fal', 'paper-plane']"
              />
              * Enviar para aprobación
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
      <!-- APPROVED -->
      <v-layout>
        <v-flex
          v-if="approved === 1"
          class="message-green"
          d-inline-flex
          align-center
          mt-2
          py-2
        >
          <font-awesome-icon
            :style="{ color: '#00E676' }"
            size="2x"
            :icon="['fal', 'check-circle']"
          />
          <h5 class="color-green pl-3">Aprobado</h5>
        </v-flex>
        <v-flex v-if="approved === 1" pt-2>
          <v-btn
            class="text-capitalize"
            color="#466EA5"
            dark
            :href="
              `https://us-central1-${projectId}.cloudfunctions.net/app/getFormatPdf?id=${currentUID}`
            "
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'file-download']"
            />
            Descargar
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- NOT APPROVED -->
      <v-layout v-if="approved === 2">
        <v-flex class="message-red" d-inline-flex align-center mt-3 pa-1>
          <font-awesome-icon
            :style="{ color: '#E53935' }"
            size="2x"
            :icon="['fal', 'exclamation-triangle']"
          />
          <v-flex>
            <h5 class="color-red pl-3">No Aprobado</h5>
            <h3 class="pl-3">Para revisión</h3>
          </v-flex>
        </v-flex>

        <v-flex class="comments-container" mt-3 pa-3>
          <h3>Comentarios Lider</h3>
          {{
            commentsLeader !== ""
              ? commentsLeader
              : "No hay comentarios por parte del lider."
          }}
        </v-flex>
      </v-layout>
      <!-- BAR -->
      <v-layout class="bar-style max-min-width" mt-3 px-3 pt-1>
        <v-flex>
          <v-tooltip bottom color="white black--text" max-width="220">
            <template v-slot:activator="{ on }">
              <font-awesome-icon
                v-on="on"
                :style="{ color: '#FFE0B2', fontSize: 16 + 'px' }"
                :icon="['fas', 'info-circle']"
              />
            </template>
            <span>
              <h6>X</h6>
              <b>Base de Trabajo:</b>
              Laboró en su lugar de trabajo originalmente asignado.
            </span>
          </v-tooltip>
          X:
          {{ xEvent }}
        </v-flex>
        <v-flex>
          <v-tooltip bottom color="white black--text" max-width="220">
            <template v-slot:activator="{ on }">
              <font-awesome-icon
                v-on="on"
                :style="{ color: '#FFE0B2', fontSize: 16 + 'px' }"
                :icon="['fas', 'info-circle']"
              />
            </template>
            <span>
              <h6>XR</h6>
              <b>Base de Trabajo Remoto:</b>
              Laboró de forma remota.
            </span>
          </v-tooltip>
          XR:
          {{ xrEvent }}
        </v-flex>
        <v-flex>
          <v-tooltip bottom color="white black--text" max-width="220">
            <template v-slot:activator="{ on }">
              <font-awesome-icon
                v-on="on"
                :style="{ color: '#FFE0B2', fontSize: 16 + 'px' }"
                :icon="['fas', 'info-circle']"
              />
            </template>
            <span>
              <h6>C</h6>
              <b>Comisión:</b>
              Laboró en comisión y viajes fuera del lugar y/o ciudad de trabajo
              originalmente asignado.
            </span>
          </v-tooltip>
          C:
          {{ cEvent }}
        </v-flex>
        <v-flex>
          <v-tooltip bottom color="white black--text" max-width="220">
            <template v-slot:activator="{ on }">
              <font-awesome-icon
                v-on="on"
                :style="{ color: '#FFE0B2', fontSize: 16 + 'px' }"
                :icon="['fas', 'info-circle']"
              />
            </template>
            <span>
              <h6>PL</h6>
              <b>Permiso Legal:</b>
              Licencias otorgadas por ley (maternidad, paternidad,
              luto,calamidad grave) – <b>debe presentar soportes.</b>
            </span>
          </v-tooltip>
          PL:
          {{ plEvent }}
        </v-flex>
        <v-flex>
          <v-tooltip bottom color="white black--text" max-width="220">
            <template v-slot:activator="{ on }">
              <font-awesome-icon
                v-on="on"
                :style="{ color: '#FFE0B2', fontSize: 16 + 'px' }"
                :icon="['fas', 'info-circle']"
              />
            </template>
            <span>
              <h6>PNR</h6>
              <b>Permiso No Remunerado:</b>
              Permiso otorgado por Experis por calamidad grave y/o casos
              especiales – <b>debe presentar soportes.</b>
            </span>
          </v-tooltip>
          PNR:
          {{ pnrEvent }}
        </v-flex>
        <v-flex>
          <v-tooltip bottom color="white black--text" max-width="220">
            <template v-slot:activator="{ on }">
              <font-awesome-icon
                v-on="on"
                :style="{ color: '#FFE0B2', fontSize: 16 + 'px' }"
                :icon="['fas', 'info-circle']"
              />
            </template>
            <span>
              <h6>I</h6>
              <b>Incapacidad:</b> Enfermedad general.
            </span>
          </v-tooltip>
          I:
          {{ iEvent }}
        </v-flex>
        <v-flex v-if="role < 1">
          <v-tooltip bottom color="white black--text" max-width="220">
            <template v-slot:activator="{ on }">
              <font-awesome-icon
                v-on="on"
                :style="{ color: '#FFE0B2', fontSize: 16 + 'px' }"
                :icon="['fas', 'info-circle']"
              />
            </template>
            <span>
              <h6>D</h6>
              <b>Descanso:</b> Días de descanso adicional otorgado. Solo aplica
              en turnos rotativos y especiales.
            </span>
          </v-tooltip>
          D:
          {{ dEvent }}
        </v-flex>
        <v-flex d-inline-flex>
          <v-flex class="total-container">
            <v-flex class="title-alt1">
              Total:
            </v-flex>
            <v-flex class="caption-alt1">
              Novedades
            </v-flex>
          </v-flex>
          <v-flex>
            {{ total }}
          </v-flex>
        </v-flex>
        <v-flex d-inline-flex>
          <v-flex class="total-container">
            <v-flex class="title-alt1">
              Total:
            </v-flex>
            <v-flex class="caption-alt1 text-xs-right pr-2">
              Días
            </v-flex>
          </v-flex>
          <v-flex>
            {{ amountOfWork }}
          </v-flex>
        </v-flex>
      </v-layout>
      <!-- CLEAR ALL EVENTS -->
      <v-layout
        v-if="
          events.length >
            holyDays.length +
              startDateEvent.length +
              endDateEvent.length +
              restrictionDatesEvents.length &&
            !(readOnlyCalendar && (approved === 0 || approved === 1))
        "
        class="max-min-width clear-events-container"
        mt-1
        pa-2
      >
        <v-spacer></v-spacer>
        <v-btn class="text-capitalize" dark color="red" @click="clearEvents">
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="lg"
            :icon="['fal', 'times-circle']"
          />
          Limpiar Todos los Eventos
        </v-btn>
      </v-layout>
      <!-- CALENDAR -->
      <v-layout class="max-min-width calendar-container" pa-3 mt-1 mb-5>
        <v-flex xs12>
          <v-sheet height="500">
            <v-calendar
              ref="calendar"
              v-model="start"
              :weekdays="weekdaysConfig"
              :short-weekdays="false"
              :short-months="false"
              :end="end"
              :type="type"
              color="#C46D24"
              locale="es-co"
              @click:day="addEvent"
              @click:date="inputDate"
              @moved="movedDate"
            >
              <template v-slot:day="{ date }">
                <v-flex v-for="(event, index) in eventsMap[date]" :key="index">
                  <!-- RESTRICTION DATE EVENTS -->
                  <v-flex
                    v-if="event.ods === 'NA'"
                    class="restriction-dates-in-calendar"
                    px-1
                  >
                    - NA
                  </v-flex>
                  <!-- END DATE EVENT -->
                  <v-flex
                    v-if="event.ods === 'endDate'"
                    class="end-date-in-calendar"
                    px-1
                    mb-1
                  >
                    Fecha de Retiro
                  </v-flex>
                  <!-- START DATE EVENT -->
                  <v-flex
                    v-if="event.ods === 'startDate'"
                    class="start-date-in-calendar"
                    px-1
                    mb-1
                  >
                    Fecha de Inicio
                  </v-flex>
                  <!-- ROLE 1  -->
                  <v-flex v-if="role === 1 && event.ods === 'holy'">
                    <v-flex class="holy-in-calendar" px-1 mb-1>
                      *Festivo
                    </v-flex>
                    <v-flex class="ods-in-calendar" px-1>
                      {{ optionsODS[event.ods] }}
                    </v-flex>
                  </v-flex>
                  <!-- ALL EVENTS -->
                  <v-flex
                    v-else-if="
                      event.ods !== 'holy' &&
                        event.ods !== 'X' &&
                        event.odsN !== 'XR'
                    "
                    class="ods-in-calendar"
                    px-1
                  >
                    {{ optionsODS[event.ods] }}
                  </v-flex>
                  <!-- HOLY DAYS -->
                  <v-flex
                    v-else-if="event.ods === 'holy'"
                    class="holy-in-calendar"
                    px-1
                    mb-1
                  >
                    *Festivo
                  </v-flex>
                  <!-- REMOTE WORK -->
                  <v-flex
                    v-else-if="event.odsN === 'XR'"
                    class="xr-in-calendar"
                    px-1
                    mb-1
                  >
                    XR - Base de Trabajo Remoto
                  </v-flex>
                  <!-- X -->
                  <v-flex v-else class="x-in-calendar" px-1 mb-1>
                    X - Base de Trabajo
                  </v-flex>
                </v-flex>
              </template>
            </v-calendar>
          </v-sheet>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CheckNormalMonth from "../components/CheckNormalMonth";
import { monthNames, odsEventNamesMap, weekDaysMap } from "../utils/datesInfo";

const projectId = process.env.VUE_APP_PROJECT_ID;

export default {
  name: "Home",
  components: { CheckNormalMonth },
  data() {
    return {
      allowedDay: true,
      projectId,
      monthWithoutEventsState: false,
      fullDateSelected: null,
      amountOfDays: 1,
      monthTotalDays: 0,
      monthTotalDaysA: 0,
      // odsMonth: 2,
      showUpdateBtn: false,
      odsSelected: 0,
      selectedDate: "",
      daySelected: null,
      monthSelected: null,
      showMenu: false,
      x: 0,
      y: 0,
      type: "month",
      events: [],
      showCheckNormalMonth: false
    };
  },
  filters: {
    monthName(value) {
      return monthNames.get(value);
    }
  },
  watch: {
    eventsFromDB() {
      // console.log("EVENTS FROM DB WATCH");
      this.events = [
        ...this.restrictionDatesEvents,
        ...this.startDateEvent,
        ...this.endDateEvent,
        ...this.holyDays,
        ...this.eventsFromDB
      ];
      // console.log("EVENTS FROM DB WATCH", this.events);
    },
    role() {
      // console.log("ROLE WATCH: ", this.role);
      if (this.role === 1) {
        // console.log("ROLE WATCH IN: ", this.role);
        const fullWork = [];
        let day = 0;
        for (let index = 1; index <= this.monthTotalDaysO; index++) {
          if (index < 10) day = `0${index}`;
          else day = `${index}`;
          const date = `${this.currentYear}-02-${day}`;
          const holyD = this.holyDays;
          const index = holyD.findIndex(item => item.date === date);
          const isHolyDay = index !== -1;
          if (!isHolyDay) {
            const fullDate = new Date(`${date}, 00:00:00`);
            const weekday = fullDate.getDay();
            if (weekday !== 0 && weekday !== 6) {
              // console.log("WEEKDAY MOUNTED WATCH: ", weekday);
              const eventDay = { date, ods: "X" };
              fullWork.push(eventDay);
            }
          }
        }
        // console.log("fullWork.length", fullWork.length);
        this.monthTotalDaysA = fullWork.length;
      }
      this.monthTotalDays =
        this.role === 0 ? this.monthTotalDaysO : this.monthTotalDaysA;
      // console.log("monthTotalDays", this.monthTotalDays, this.monthTotalDaysO);
    },
    monthTotalDaysO() {
      // console.log("monthTotalDaysO WATCH: ", this.role);
      if (this.role === 1) {
        // console.log("ROLE WATCH IN: ", this.role);
        const fullWork = [];
        let day = 0;
        for (let index = 1; index <= this.monthTotalDaysO; index++) {
          if (index < 10) day = `0${index}`;
          else day = `${index}`;
          const date = `${this.currentYear}-02-${day}`;
          const holyD = this.holyDays;
          const index = holyD.findIndex(item => item.date === date);
          const isHolyDay = index !== -1;
          if (!isHolyDay) {
            const fullDate = new Date(`${date}, 00:00:00`);
            const weekday = fullDate.getDay();
            if (weekday !== 0 && weekday !== 6) {
              // console.log("WEEKDAY MOUNTED WATCH: ", weekday);
              const eventDay = { date, ods: "X" };
              fullWork.push(eventDay);
            }
          }
        }
        // console.log("fullWork.length", fullWork.length);
        this.monthTotalDaysA = fullWork.length;
      }

      this.monthTotalDays =
        this.role === 0 ? this.monthTotalDaysO : this.monthTotalDaysA;
      // console.log(
      //   "WATCH monthTotalDaysO",
      //   this.monthTotalDays,
      //   this.monthTotalDaysO
      // );
    }
  },
  computed: {
    ...mapGetters([
      "currentMonthNumberST",
      "numberOfDaysST",
      "amountOfRestrictionDaysST",
      "amountOfWork",
      "restrictionDatesEvents",
      "endDateEvent",
      "startDateEvent",
      "currentSTMonth",
      "startCalendar",
      "endCalendar",
      "currentYear",
      "currentMonth",
      "currentMonthNumber",
      "currentRealMonth",
      "currentRealMonthNumber",
      "endDate",
      "startDate",
      "holyDays",
      "currentUID",
      "role",
      "commentsLeader",
      "loading",
      "readOnlyCalendar",
      "eventsFromDB",
      // "message",
      "approved"
    ]),
    ...mapGetters({
      monthTotalDaysO: "realMonthTotalDays"
    }),
    start: {
      get() {
        return this.startCalendar;
      },
      set(value) {
        return value;
      }
    },
    end: {
      get() {
        return this.endCalendar;
      },
      set(value) {
        return value;
      }
    },
    checkEndDate() {
      let result = false;
      if (this.endDate !== null) {
        const endDateMonth = Number(this.endDate.split("/")[1]);
        // console.log("END DATE MONTH", endDateMonth, this.currentMonthNumber);
        if (endDateMonth !== this.currentMonthNumber) result = true;
      }
      return result;
    },
    // month() {
    //   return monthNames.get(this.currentMonthNumber);
    // },
    sendButton() {
      let value = true;
      if (
        this.events.length >
        this.holyDays.length +
          this.startDateEvent.length +
          this.endDateEvent.length +
          this.restrictionDatesEvents.length
      )
        value = false;
      // if (this.readOnlyCalendar && (this.approved === 0 || this.approved === 1))
      //   value = false;
      // console.log("SEND BUTTON: ", value);
      return value;
    },
    maxDays() {
      // const limit = this.monthTotalDaysO + 1;
      let limit;
      if (this.currentMonth === this.currentSTMonth)
        limit = this.amountOfWork + this.amountOfRestrictionDaysST + 1;
      else if (this.currentMonth === this.currentRealMonth)
        limit = this.amountOfWork + 1;

      // when the enDate is in the same ST month check the limit with this
      if (this.endDate !== null) {
        const endDateSplit = this.endDate.split("/");
        const endDateDay = Number(endDateSplit[0]);
        const endDateMonth = Number(endDateSplit[1]);
        const endDateYear = endDateSplit[2];

        if (
          endDateMonth === this.currentMonthNumberST &&
          endDateYear === this.currentYear
        ) {
          const offSet = this.numberOfDaysST - endDateDay;
          const startOffSet =
            this.amountOfWork + this.amountOfRestrictionDaysST + 1;
          limit = startOffSet - offSet;
        }
      }

      let maxD = limit - this.daySelected;
      return maxD;
    },
    optionsODS() {
      let options = [
        "XR - Base de Trabajo Remoto",
        "C - Comisión",
        "PL - Permiso Legal",
        "PNR - Permiso no remunerado",
        "I - Incapacidad"
      ];
      if (this.role === 0) options.push("D - Descanso");
      else if (this.role === 1 && this.readOnlyCalendar)
        options.push("D - Descanso");
      return options;
    },
    weekdaysConfig() {
      let weekdays = [0, 1, 2, 3, 4, 5, 6];
      if (this.role === 1) weekdays = [1, 2, 3, 4, 5];
      return weekdays;
    },
    xEvent() {
      // const total = this.total;
      // // return this.monthTotalDays - total;
      // return this.amountOfWork - total;
      const items = this.events.filter(item => item.ods === "X");
      return items.length;
    },
    xrEvent() {
      const items = this.events.filter(item => item.ods === 0);
      return items.length;
    },
    cEvent() {
      const items = this.events.filter(item => item.ods === 1);
      return items.length;
    },
    plEvent() {
      const items = this.events.filter(item => item.ods === 2);
      return items.length;
    },
    pnrEvent() {
      const items = this.events.filter(item => item.ods === 3);
      return items.length;
    },
    iEvent() {
      const items = this.events.filter(item => item.ods === 4);
      return items.length;
    },
    dEvent() {
      const items = this.events.filter(item => item.ods === 5);
      return items.length;
    },
    odsAlt: {
      get() {
        let value = 0;
        const index = this.events.findIndex(
          item => item.date === this.selectedDate
        );
        const eventsDay = this.events.filter(
          item => item.date === this.selectedDate
        );
        // console.log("INDEX: ", index);
        if (
          eventsDay.length === 1 &&
          this.events[index].ods !== "holy" &&
          this.events[index].ods !== "startDate" &&
          this.events[index].ods !== "endDate"
        )
          value = this.events[index].ods;
        else if (eventsDay.length === 2) value = eventsDay[1].ods;
        // console.log("THERE IS EVENT: ", value);
        return value;
      },
      set(value) {
        this.odsSelected = value;
        const index = this.events.findIndex(
          item => item.date === this.selectedDate
        );
        const eventsDay = this.events.filter(
          item => item.date === this.selectedDate
        );
        // console.log("INDEX SET: ", index, eventsDay);
        if (
          eventsDay.length === 1 &&
          this.events[index].ods !== "holy" &&
          this.events[index].ods !== "startDate" &&
          this.events[index].ods !== "endDate"
        ) {
          // console.log(eventsDay[0].ods);
          // console.log(this.events[index].ods);
          if (this.events[index].ods !== value) this.showUpdateBtn = true;
          else this.showUpdateBtn = false;
        } else if (eventsDay.length === 2) {
          if (eventsDay[1].ods !== value) this.showUpdateBtn = true;
          else this.showUpdateBtn = false;
        }
      }
    },
    notEvent() {
      let notEvent = true;
      const eventsDay = this.events.filter(
        item => item.date === this.selectedDate
      );
      // console.log("EVENTS DAY: ", eventsDay);
      if (eventsDay.length === 1) {
        if (
          eventsDay[0].ods === "startDate" ||
          eventsDay[0].ods === "endDate" ||
          eventsDay[0].ods === "holy"
        )
          notEvent = true;
        else notEvent = false;
      } else if (eventsDay.length === 2) notEvent = false;
      return notEvent;
    },
    total() {
      let total =
        this.xrEvent + this.cEvent + this.plEvent + this.pnrEvent + this.iEvent;

      if (this.role === 0) total = total + this.dEvent;
      return total;
    },
    eventsMap() {
      const map = {};
      this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map;
    }
  },
  methods: {
    ...mapActions(["showGeneralMessage"]),
    backSTMonth() {
      this.$store.commit("CHANGE_CURRENT_REAL_YEAR");
      this.$store.commit("CHANGE_CURRENT_REAL_MONTH");
      this.$store.commit("SET_START_END_CALENDAR");
      this.$store.commit("SET_HOLY_DAYS");
      // this.odsMonth = this.currentMonthNumber;
      this.$store.dispatch("fetchEvents");
    },
    showMessageEndDate() {
      const payload = {
        showMessage: true,
        showCancelBtn: false,
        showSendBtn: false,
        showOkBtn: true,
        action: "",
        data: null,
        messageTitle: "Acción Requerida",
        messageInfo: `Se debe contar con la Aprobación del Service Ticket del mes de ${
          this.currentMonth
        } para poder diligenciar el Service Ticket del mes de ${
          this.currentRealMonth
        }`
      };
      this.$store.commit("SET_GENERAL_MESSAGE", payload);
    },
    formatDateSC(date) {
      const dateSplit = date.split("/");
      const dayDate = dateSplit[0];
      const monttDate = dateSplit[1];
      const yearDate = dateSplit[2];
      const dateFormated = `${yearDate}-${monttDate}-${dayDate}`;
      return dateFormated;
    },
    checkNextMonth() {
      // console.log("CHECK NEXT MONTH");
      if (this.eventsFromDB.length === 0) this.showMessageEndDate();
      else {
        if (this.approved !== 1) this.showMessageEndDate();
        else {
          // console.log("CHECK NEXT MONTH OK");
          // this.odsMonth = this.currentRealMonthNumber;
          this.$store.commit("CHANGE_CURRENT_MONTH");
          this.$store.commit("SET_START_END_CALENDAR");
          this.$store.commit("SET_HOLY_DAYS");
          this.$store.dispatch("fetchEvents");
        }
      }
    },
    monthWithoutEvents(typeBaseWork) {
      const fullWork = [];
      let day = 0;
      const monthWE =
        this.currentMonthNumber < 10
          ? `0${this.currentMonthNumber}`
          : `${this.currentMonthNumber}`;

      const payloadEvent =
        typeBaseWork === 0 ? { ods: "X" } : { ods: 0, odsN: "XR" };

      for (let index = 1; index <= this.monthTotalDaysO; index++) {
        if (index < 10) day = `0${index}`;
        else day = `${index}`;
        const date = `${this.currentYear}-${monthWE}-${day}`;
        const holyD = this.holyDays;
        const index = holyD.findIndex(item => item.date === date);
        const isHolyDay = index !== -1;
        const fullDate = new Date(`${date}, 00:00:00`);
        const weekday = fullDate.getDay();
        const nameDay = weekDaysMap.get(weekday);
        if (this.role === 1) {
          if (!isHolyDay) {
            // const fullDate = new Date(`${date}, 00:00:00`);
            // const weekday = fullDate.getDay();
            if (weekday !== 0 && weekday !== 6) {
              // console.log("WEEKDAY: ", weekday);
              const eventDay = { date, nameDay, ...payloadEvent };
              fullWork.push(eventDay);
            }
          }
        } else {
          const restrictionD = this.restrictionDatesEvents;
          const indexRD = restrictionD.findIndex(item => item.date === date);
          const isNotRestricted = indexRD === -1;
          if (isNotRestricted) {
            const eventDay = { date, nameDay, ...payloadEvent };
            fullWork.push(eventDay);
          }
        }
      }
      // console.log("FULL WORK: ", fullWork);
      this.events = [
        ...this.restrictionDatesEvents,
        ...this.startDateEvent,
        ...this.endDateEvent,
        ...this.holyDays,
        ...fullWork
      ];
      this.monthWithoutEventsState = true;
    },
    clearEvents() {
      this.events = [];
      this.events = [
        ...this.restrictionDatesEvents,
        ...this.startDateEvent,
        ...this.endDateEvent,
        ...this.holyDays
      ];
      this.monthWithoutEventsState = false;
    },
    movedDate() {
      // console.log("MOVED DATE: ", date);
      this.start = this.startCalendar;
      this.end = this.endCalendar;
    },
    inputDate(date) {
      // console.log("TESTING EVENTS", date.month);
      if (date.month !== this.currentMonthNumber) {
        // console.log("NOT ALLOWED");
        this.$refs.calendar.move();
      }
    },
    sendODSConfirm() {
      const payload = {
        showMessage: true,
        showTextArea: true,
        messagesComments:
          "Por favor ingrese los comentarios relacionados con el Service Ticket que está a punto de enviar.",
        showCancelBtn: true,
        showSendBtn: true,
        showOkBtn: false,
        action: "sendODS",
        data: this.events,
        messageTitle: "Confirmar envio para revisión",
        messageInfo: `Esta a punto de enviar para revisión las novedades del mes de ${
          this.currentMonth
        }. Una vez enviado satisfactoriamente no se podra cambiar la información, a menos que el Lider lo solicite`
      };
      this.showGeneralMessage(payload);
      // this.sendODS(this.events);
    },
    sendODSConfirmRev() {
      const payload = {
        showMessage: true,
        showTextArea: true,
        messagesComments:
          "Por favor ingrese los comentarios relacionados con el Service Ticket que está a punto de enviar para una nueva revisión.",
        showCancelBtn: true,
        showSendBtn: true,
        showOkBtn: false,
        action: "sendODSRev",
        data: this.events,
        messageTitle: "Confirmar envio para revisión",
        messageInfo: `Esta a punto de enviar para revisión las novedades del mes ${
          this.currentMonth
        }. Una vez enviado satisfactoriamente no se podra cambiar la información, a menos que el Lider lo solicite`
      };
      this.showGeneralMessage(payload);
      // this.sendODS(this.events);
    },
    updateEvent() {
      // const eventDay = this.events.filter(item => item.date === this.selectedDate);
      const index = this.events.findIndex(
        item =>
          item.date === this.selectedDate &&
          item.ods !== "holy" &&
          item.ods !== "startDate" &&
          item.ods !== "endDate"
      );
      const fullDate = new Date(`${this.selectedDate}, 00:00:00`);
      const weekday = fullDate.getDay();
      const obj = {
        date: this.selectedDate,
        ods: this.odsSelected,
        odsN: odsEventNamesMap.get(this.odsSelected),
        nameDay: weekDaysMap.get(weekday)
      };
      if (index >= 0) this.events.splice(index, 1, obj);
      this.showMenu = false;
      this.showUpdateBtn = false;
      this.odsSelected = 0;
    },
    deleteEvent() {
      const index = this.events.findIndex(
        item =>
          item.date === this.selectedDate &&
          item.ods !== "holy" &&
          item.ods !== "startDate" &&
          item.ods !== "endDate"
      );
      // console.log("INDEX: ", index);
      // const eventDay = this.events.filter(item => item.date === this.selectedDate);
      // console.log("EVENT DAY: ", eventDay);
      if (index >= 0) this.events.splice(index, 1);
      this.showMenu = false;
      this.showUpdateBtn = false;
      this.odsSelected = 0;
    },
    closeMenu() {
      this.showMenu = false;
      this.showUpdateBtn = false;
      this.odsSelected = 0;
    },
    newEvent() {
      let weekDay = this.fullDateSelected.weekday;
      let day = this.daySelected;
      for (let index = 0; index < this.amountOfDays; index++) {
        // console.log("WEEKDAY: ", weekDay, index, this.role);
        // console.log("DAY: ", day, index, this.monthTotalDaysO);
        if (day > this.monthTotalDaysO) break;
        const partDate = this.selectedDate.slice(0, 8);
        if (this.role === 1 && weekDay > 5) {
          day = day + 2;
          weekDay = 1;
        }
        // else {
        //   weekDay++;
        // }
        const date = day < 10 ? `${partDate}0${day}` : `${partDate}${day}`;
        weekDay++;
        day++;
        // console.log("DATE: ", date, index, day);
        const indexEvents = this.events.findIndex(
          item =>
            item.date === date &&
            item.ods !== "holy" &&
            item.ods !== "startDate" &&
            item.ods !== "endDate"
        );
        // console.log("INDEX EVENT: ", indexEvents);
        if (indexEvents > 0) this.events.splice(indexEvents, 1);
        const fullDate = new Date(`${date}, 00:00:00`);
        const weekday = fullDate.getDay();
        this.events.push({
          date,
          ods: this.odsSelected,
          odsN: odsEventNamesMap.get(this.odsSelected),
          nameDay: weekDaysMap.get(weekday)
        });
      }
      this.showMenu = false;
      this.showUpdateBtn = false;
      this.odsSelected = 0;
      // console.log("NEW EVENT: ", this.events, e, event)
    },
    getStartEndDateRestriction(day) {
      let finalResult = true;
      // let startDateSplit;
      // let endDateSplit;
      let startDateFormated;
      let endDateFormated;

      // START DATE
      // startDateSplit = this.startDate.split("/");
      // const dayStartDate = startDateSplit[0];
      // const monthStartDate = startDateSplit[1];
      // const yearStartDate = startDateSplit[2];
      // startDateFormated = `${yearStartDate}-${monthStartDate}-${dayStartDate}`;
      startDateFormated = this.formatDateSC(this.startDate);
      // console.log("START DATE FORMATED: ", startDateFormated);

      // END DATE
      // let dayEndDate;
      // let monthEndDate;
      // let yearEndDate;
      if (this.endDate !== null) {
        // endDateSplit = this.endDate.split("/");
        // dayEndDate = endDateSplit[0];
        // monthEndDate = endDateSplit[1];
        // yearEndDate = endDateSplit[2];
        // endDateFormated = `${yearEndDate}-${monthEndDate}-${dayEndDate}`;
        endDateFormated = this.formatDateSC(this.endDate);
        // console.log("END DATE FORMATED: ", endDateFormated);
      }

      const selectedDate = day.date;

      if (this.endDate !== null) {
        if (selectedDate < startDateFormated || selectedDate > endDateFormated)
          finalResult = false;
        else finalResult = true;
      } else {
        if (selectedDate < startDateFormated) finalResult = false;
        else finalResult = true;
      }

      this.allowedDay = finalResult;
    },
    addEvent(day) {
      if (this.monthWithoutEventsState) return;

      // console.log("this.endDate", this.endDate);

      // RESTRICTION FOR START DATE
      this.getStartEndDateRestriction(day);

      this.fullDateSelected = day;
      // console.log("DAY: ", day, day.date);
      this.amountOfDays = 1;
      const holyD = this.holyDays;
      const index = holyD.findIndex(item => item.date === day.date);
      const isHolyDay = index !== -1;
      // console.log("IS HOLY DAY: ", isHolyDay);
      if (this.readOnlyCalendar && (this.approved === 0 || this.approved === 1))
        console.log("CALENDAR DISABLED!");
      else if (
        day.month !== this.currentMonthNumber ||
        (isHolyDay && this.role === 1)
      ) {
        // console.log("NOT ALLOWED DATE!");
        this.showMenu = false;
      } else {
        // console.log("ADD EVENT: ", day, event, event.clientX, event.clientY)
        event.preventDefault();
        this.showMenu = false;
        this.showUpdateBtn = false;
        this.x = event.clientX;
        this.y = event.clientY;
        this.selectedDate = day.date;
        this.daySelected = day.day;
        this.monthSelected = day.month;
        this.$nextTick(() => {
          this.showMenu = true;
        });
      }
    }
    // open(event) {
    //   alert(event.title);
    // }
  },
  mounted() {
    this.$nextTick(() => {
      this.events = this.holyDays;
      // console.log("ROLE HOME: ", this.role);
    });
  }
};
</script>

<style lang="stylus" scoped>
h2
  font-size 32px
  color black
  font-weight 500

h3
  font-size 18px
  color #717171
  font-weight 400
// .container
//   max-width 1024px
//   min-width 1024px

h5
  font-size 21px
  font-weight 500

h6
  font-size 18px
  font-weight 600
  color black

.restriction-dates-in-calendar
  background-color #757575
  background-image url('../assets/pattern-2.svg')
  background-repeat repeat
  color #BDBDBD
  border-radius 2px
  cursor not-allowed

.end-date-in-calendar
  background-color #F44336
  color white
  border-radius 2px
  cursor pointer

.start-date-in-calendar
  background-color #4CAF50
  color white
  border-radius 2px
  cursor pointer

.total-container
  max-width 65px
  min-width 65px

.title-alt1
  font-size 24px
  font-weight 500

.caption-alt1
  font-size 11px
  padding-left 5px
  margin-top -10px

.buttons-up-container
  background-color #EEEEEE
  border-radius 8px

.clear-events-container
  background-color #EEEEEE
  border-radius 8px

.calendar-container
  background-color #F5F5F5
  border-radius 8px

.text-9
  font-size 9px

.label-width
  max-width 60px

.max-days-style
  max-width 50px
  border-left 1px solid silver

.comments-container
  background-color #E0E0E0
  border-radius 8px
  max-width 800px
  min-width 800px
  margin-left 24px

.message-red
  // height 70px
  max-width 200px
  min-width 200px
  // padding-bottom 40px
  padding-left 10px
  padding-right 10px
  border  solid 2px #E53935
  border-radius 8px

.message-green
  // height 40px
  max-width 200px
  min-width 200px
  // padding-bottom 45px
  padding-left 10px
  padding-right 10px
  border solid 2px #00E676
  border-radius 8px

.color-green
  color #00E676

.color-red
  color #E53935

.close-btn-style
  margin-top 47px

.line-1
  border-left 1px solid rgba(255, 255, 255, 0.5)
  border-right 1px solid rgba(255, 255, 255, 0.5)

.day-text-style
  font-size 36px
  font-weight 600
  max-width 45px

.month-text-style
  font-size 23px
  font-weight 400

.ods-in-calendar
  background-color #C46D24
  color white
  border-radius 2px
  cursor pointer

.x-in-calendar
  background-color #466EA5
  color white
  border-radius 2px
  cursor pointer

.xr-in-calendar
  background-color #5E35B1
  color white
  border-radius 2px
  cursor pointer

.holy-in-calendar
  background-color #BDBDBD
  color white
  border-radius 2px
  cursor pointer

.orange-mp
  background-color #C46D24
  color white

.title-section
  font-size 40px
  font-weight 700
  color #C46D24
  max-width 150px
  min-width 150px

.max-min-width
  max-width 1024px
  min-width 1024px

.bar-style
  background-color #C46D24
  border-radius 8px
  height 50px
  font-size 28px
  color white
</style>
